export default "__VITE_ASSET__YqdhrSlZ__"